import { useFeatureLoyaltyInRestaurantRedemptionQuery } from 'generated/sanity-graphql';
import { FEATURE_LOYALTY_UI_SINGLETON } from 'hooks/use-feature-loyalty-ui/use-feature-loyalty-ui';

export const useFeaturesInRestaurantRedemption = () => {
  const { data, loading } = useFeatureLoyaltyInRestaurantRedemptionQuery({
    variables: { featureLoyaltyUIId: FEATURE_LOYALTY_UI_SINGLETON },
    fetchPolicy: 'cache-and-network',
  });
  return {
    data: data?.LoyaltyUI?.loyaltyInRestaurantRedemption,
    loading,
  };
};
